import * as yup from 'yup'

export const schema = yup.object({
    // Removidos todos os campos de signatário e remetente
})